import React from 'react';
import Spacing from '../../portico/spacing/spacing';
import { useDocumentRequirementsStyles } from './document-requirements.styles';
import Typography from '@material-ui/core/Typography';
import STATIC_TEXT from '../../../content/common.json';
import { isUSEntity } from '../../../utils/fenergo-utils';
import { useEntityState } from '../../../stores/entity/entity.hooks';

export const CompanyDocumentRequirements: React.FC = () => {
    const classes = useDocumentRequirementsStyles();
    const { entityDraft } = useEntityState();

    return (
        <>
        {isUSEntity(entityDraft)? 
                // US content
                <>
                    <Typography variant="body1">{STATIC_TEXT.welcome.docs.companyDocumentsUS.line1}</Typography>
                    <Spacing variable="spacing-base-x3" />
                    <div className={classes.docListingWrapper}>
                        <Typography className="doc_listing">{STATIC_TEXT.welcome.docs.personalInformationUS.address}</Typography>
                        <ul className={classes.listItem}>
                            {
                                STATIC_TEXT.welcome.docs.personalInformationUS.addressProof
                                    .map((_address, _index) => <li key={_index}>{_address}</li>)
                            }
                        </ul>
                    </div>
                    <div className={classes.docListingWrapper}>
                        <Typography className="doc_listing">{STATIC_TEXT.welcome.docs.personalInformationUS.information}</Typography>
                        <ul className={classes.listItem}>
                            {
                                STATIC_TEXT.welcome.docs.personalInformationUS.informationProof
                                    .map((_information, _index) => <li key={_index}>{_information}</li>)
                            }
                        </ul>
                    </div>
                </> :

                // non-US content
                <>
                    <Typography variant="body1">{STATIC_TEXT.welcome.docs.companyDocumentsUK.line1}</Typography>
                    <Spacing variable="spacing-base-x3" />
                    <ul className={classes.listItem}>
                        {
                            STATIC_TEXT.welcome.docs.companyDocumentsUK.informationProof
                                .map((_information, _index) => <li key={_index}>{_information}</li>)
                        }
                    </ul>
                    <Typography variant="body1">{STATIC_TEXT.welcome.docs.companyDocumentsUK.paragraph2}</Typography>
                </>
        }
    </>);
};
